import React, { useState } from "react";
import "../App.css";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import { CardMedia, Typography } from "@material-ui/core";
import HighlightTitle from "./HighlightTitle";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

export interface ProjectData {
  title: string;
  color: string;
  description: string;
  imgPath: string;
  direction: number;
  tags: Array<string>;
  path: string;
}

const useStyles = makeStyles((theme) => ({
  project: {
    display: "flex",
    elevation: 0,
    raised: false,
    marginTop: "1em",
    flexWrap: "nowrap",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    padding: 0,
  },
  cover: {
    flex: 1,
    maxHeight: "50vh",
    maxWidth: "50vw",
    transform: "scale(1)",
    transition: "transform .3s",
  },
  coverHovered: {
    transform: "scale(1.07)",
    transition: "transform .3s",
  },
  tag: {
    borderRadius: 15,
    background: "#F0F0F0",
    borderColor: "lightgrey",
    border: "solid 1px",

    paddingLeft: "8px",
    paddingRight: "9px",
    paddingTop: "3px",
    paddingBottom: "2px",
    
    marginTop: ".75em",
    marginRight: "0.5em",

    alignContent: "center",
    textAlign: "center",
    // textTransform: "uppercase",
  },
}));

export default function ProjectItem({
  title,
  color,
  description,
  imgPath,
  direction,
  tags,
  path,
}: ProjectData) {
  const classes = useStyles();
  let tagElements: JSX.Element[] = [];

  var contentOrder = {
    order: direction % 2 ? 2 : 0,
  };
  var imageOrder = {
    order: direction % 2 ? 1 : 0,
  };

  var history = useHistory();
  var clickHandler = () => {
    history.push("/project/" + path);
  };

  const [state, setState] = useState({
    hover: false,
  });

  tags.forEach((tag) => {
    tagElements.push(
      <div className={classes.tag}>
        <Typography variant="body2">{tag}</Typography>
      </div>
    );
  });

  return (
    <div className={classes.project}>
      <CardContent className={classes.content} style={contentOrder}>
        <HighlightTitle title={title} color={color} />
        <Typography variant="subtitle1" color="textSecondary">
          {description}
        </Typography>
        <Grid container direction="row" justify="flex-start" spacing={1}>
          {tagElements}
        </Grid>
      </CardContent>
      <CardMedia
        component="img"
        className={classes.cover}
        classes={{ root: state.hover ? classes.coverHovered : "" }}
        image={imgPath}
        style={imageOrder}
        onMouseOver={() => setState({ hover: true })}
        onMouseOut={() => setState({ hover: false })}
        onClick={clickHandler}
      />
    </div>
  );
}
